import React, { useMemo } from 'react';
import FormInput from 'components/Input/FormInput';
import { Rule, RuleObject } from 'antd/lib/form';
import { StoreValue } from 'antd/lib/form/interface';
import { useTranslation } from 'react-i18next';

interface IHardwareIdField {
	changeHardwareId: (value: string) => void;
}

const HardwareIdField: React.FC<IHardwareIdField> = ({ changeHardwareId }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(
		() => [
			{ required: true, message: t('enterHardwareId') },
			() => ({
				validator(_: RuleObject, value: StoreValue) {
					if (value.length <= 64) {
						return Promise.resolve();
					}
					return Promise.reject(new Error(t('valueMustContainNoMore', { value: 64 })));
				},
			}),
		],
		[],
	);

	return (
		<FormInput
			testId="HardwareIdField"
			name="hardwareId"
			label="hardwareIdLabel"
			onChange={changeHardwareId}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(HardwareIdField);
